import React from 'react';
import PropTypes from 'prop-types';
import './deleteable-input.scss';


const DeleteableDiv = (props) => {
  return (
    <React.Fragment>
      <div className="text">{props.value}</div>
      <div className='btn-delete' onClick={() => props.onDelete(props.inputName)}>X</div>
    </React.Fragment>
  )
}

DeleteableDiv.propTypes = {
  value: PropTypes.string.isRequired,
  inputName: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
}

const DeleteableInputComp = (props) => {
  return (
    <React.Fragment>
      <input className="input-text" name={props.inputName} value={props.value} onChange={props.onChange}/>
      <div className='btn-delete' onClick={() => props.onDelete(props.inputName)}>X</div>
    </React.Fragment>
  )
}
DeleteableInputComp.propTypes = {
  value: PropTypes.string.isRequired,
  inputName: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
}

const DeletableInput = (props) => {
  const { value, isEditable, onChange, onDelete, inputName } = props;
  return (
    <div className="deleteable-input">
      {
        isEditable ? (
          <DeleteableInputComp value={value} inputName={inputName} onChange={onChange} onDelete={onDelete} />
        ) : (
            <DeleteableDiv value={value} onDelete={onDelete} inputName={inputName}/>
        )
      }
    </div>
  )
}

DeletableInput.defaultProps = {
  isEditable: false,
  onChange: () => {},
}
DeletableInput.propTypes = {
  inputName: PropTypes.string.isRequired,
  isEditable: PropTypes.bool,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  onDelete: PropTypes.func.isRequired,
}

export default DeletableInput;


// WEBPACK FOOTER //
// ./src/components/Common/DeleteableInput/index.js